const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  name: state => state.user.name,
  isLogin: state => state.user.isLogin,
  authority: state => state.user.authority,
  asyncRoutesAdded: state => state.router.asyncRoutesAdded,
  router: state => state.router.router,
  showRouter: state => state.router.showRouter,
  addRouters: state => state.router.addRouters,
  userInfo: state => state.user.userinfo,
  isResetPaw: state => state.user.isResetPaw,
  isComplete: state => state.user.isComplete,
  associationInfo: state => state.user.associationInfo,
  fromRouter: state => state.router.fromRouter,
  fromRouterPath: state => state.router.fromRouterPath,
  pageStack: state => state.router.pageStack,
  reloadKeepAliveTrrigger: state => state.router.reloadKeepAliveTrrigger,
  dictMap: state => state.dict.dictMap,
  dictLabel: state => state.dict.dictLabel
}
export default getters
